export default __webpack_public_path__ + "resources/icons/d141-c3b0.webp";